import * as React from "react";
import { List } from "@grandvisionhq/common";
import { Heading, Hr } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
import BenefitsList from "../../../../../components/BenefitsList/CCC/components/BenefitsList/BenefitsList.js";
/* empty css                     */
const hardCodedUspList = [
  "Free solutions for monthly lenses",
  "Manage your subscription online",
  "Free trials of the latest products",
  "Free replacement lenses"
];
const hardCodedBenefitsList = [
  {
    iconName: "eye-test",
    title: "Free annual eye test",
    subtitle: "Including free retinal photography"
  },
  {
    iconName: "discount-bubble",
    title: "50% off",
    subtitle: "Glasses and prescription and non-prescription sunglasses"
  },
  {
    iconName: "truck",
    title: "Free home delivery",
    subtitle: `Never be left out of your lenses, we'll deliver them to your door`
  },
  {
    iconName: "business",
    title: "Free service",
    subtitle: "Free expert aftercare service"
  }
];
const NoSubscriptions = () => {
  const { getLabel, getFormattedLabel, hasLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("div", { className: "no-subscriptions" }, hasLabel("account.ccc.noSubscriptions.help") && /* @__PURE__ */ React.createElement("p", { className: "no-subscriptions__help" }, getFormattedLabel("account.ccc.noSubscriptions.help", { parseHTML: true })), /* @__PURE__ */ React.createElement("p", { className: "no-subscriptions__description" }, getLabel("account.ccc.noSubscriptions.description")), /* @__PURE__ */ React.createElement("section", null, /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h2" }, getLabel("account.ccc.noSubscriptions.benefits.title")), /* @__PURE__ */ React.createElement(BenefitsList, { className: "no-subscriptions__benefits-list", items: hardCodedBenefitsList })), /* @__PURE__ */ React.createElement(Hr, null), /* @__PURE__ */ React.createElement("section", null, /* @__PURE__ */ React.createElement(
    List,
    {
      className: "no-subscriptions__checkmark-list",
      icon: "checkmark",
      items: hardCodedUspList
    }
  )));
};
export {
  NoSubscriptions as default
};
//# sourceMappingURL=NoSubscriptions.js.map
